<template>
    <div class="flex items-center">
         <span>{{ showBank(params.value) }}</span>
    </div>
</template>

<script>
export default {
  name: 'CellRendererBank',
  methods: {
    showBank (bank) {
       if(bank === 'bankokbank'){
           return 'BBL';
       }else if(bank === 'krungsri'){
           return 'BAY';
       }else return bank;
    }
  }
}
</script>